import type { ChartInterval, Horizon } from '../types/market.js';

export const HORIZONS: Array<{ value: Horizon; label: string; seconds: number }> = [
  { value: '5m', label: '5 minutes', seconds: 300 },
  { value: '15m', label: '15 minutes', seconds: 900 },
  { value: '30m', label: '30 minutes', seconds: 1_800 },
  { value: '1h', label: '1 hour', seconds: 3_600 },
  { value: '4h', label: '4 hours', seconds: 14_400 },
];

export const CHART_INTERVALS: Array<{ value: ChartInterval; label: string; seconds: number }> = [
  { value: '1m', label: '1m', seconds: 60 },
  { value: '5m', label: '5m', seconds: 300 },
  { value: '15m', label: '15m', seconds: 900 },
  { value: '30m', label: '30m', seconds: 1_800 },
  { value: '1h', label: '1h', seconds: 3_600 },
  { value: '2h', label: '2h', seconds: 7_200 },
  { value: '4h', label: '4h', seconds: 14_400 },
  { value: '1d', label: '1D', seconds: 86_400 },
  { value: '1w', label: '1W', seconds: 604_800 },
];

export const INTERVAL_SECONDS: Record<ChartInterval | Horizon, number> = {
  '1m': 60,
  '5m': 300,
  '15m': 900,
  '30m': 1_800,
  '1h': 3_600,
  '2h': 7_200,
  '4h': 14_400,
  '1d': 86_400,
  '1w': 604_800,
};

export function toBinanceInterval(interval: ChartInterval): string {
  return interval;
}
